import * as React from "react";
import {
  RouteComponentProps,
  Switch,
  useRouteMatch,
} from "react-router-dom";
import { AuthedRoutes } from "../components/AuthedRoutes";
import CVBuilderPage from "../pages/cv-builder/cv-builder";

export const cvBuilderRoutes = (props: RouteComponentProps) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  let { path } = useRouteMatch();
  
  return (
    <>
      <Switch>
        <AuthedRoutes
          menu="cv-builder"
          path={`${path}/`}
          exact={true}
          component={CVBuilderPage}
          headerTitle="CV Builder"
          noPadding={true}
        />
      </Switch>
    </>
  );
};